import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Certification  {
    _originalTypeClassName = "zERP.BO.Certification";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Certification.translate = translateService;
}
this.Id = null;
this.Code = null;
this.Revnum = null;
this.Status = null;
this.ValidFrom = null;
this.ValidTo = null;
this.Description = null;
this.Comment = null;
this.Duration = null;
this.Mandatory = false;
this.SpecificValidityDuration = false;
this.ValidityDuration = null;
this.Cost = null;
this.DocumentType = null;
this.DocumentDescription = null;
this.DocumentPath = null;
this.hasActiveContract = false;
this.State = null;
this.StatePrevious = null;
this.HRState = null;
this.HRComment = null;
this.EmpComment = null;
this.IsHRAdd = false;
this.VerifyLink = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Code:any;
Revnum:any;
Status:any;
ValidFrom:any;
ValidTo:any;
Description:any;
Comment:any;
Duration:any;
Mandatory:any;
SpecificValidityDuration:any;
ValidityDuration:any;
Cost:any;
DocumentType:any;
DocumentDescription:any;
DocumentPath:any;
hasActiveContract:any;
State:any;
StatePrevious:any;
HRState:any;
HRComment:any;
EmpComment:any;
IsHRAdd:any;
VerifyLink:any;
Employee:any;
KnowledgeDomain:any;
CertificationType:any;
CertificationLevel:any;
CategoryCertification:any;
EmployeeCategory:any;
CertificationName:any;
CertificationFileData:any;
static setEmployee = ($this, value) => {
var oldValue = $this.Employee;
$this.Employee = value;
if (value != null) {
if (oldValue != null) {
Domain.Employee.removeCertification(oldValue, $this);
}
Domain.Employee.addCertification(value, $this);
}
}
static setKnowledgeDomain = ($this, value) => {
var oldValue = $this.KnowledgeDomain;
$this.KnowledgeDomain = value;
if (value != null) {
}
}
static setCertificationType = ($this, value) => {
var oldValue = $this.CertificationType;
$this.CertificationType = value;
if (value != null) {
}
}
static setCertificationLevel = ($this, value) => {
var oldValue = $this.CertificationLevel;
$this.CertificationLevel = value;
if (value != null) {
}
}
static setCategoryCertification = ($this, value) => {
var oldValue = $this.CategoryCertification;
$this.CategoryCertification = value;
if (value != null) {
}
}
static setEmployeeCategory = ($this, value) => {
var oldValue = $this.EmployeeCategory;
$this.EmployeeCategory = value;
if (value != null) {
}
}
static setCertificationName = ($this, value) => {
var oldValue = $this.CertificationName;
$this.CertificationName = value;
if (value != null) {
}
}
static setCertificationFileData = ($this, value) => {
var oldValue = $this.CertificationFileData;
$this.CertificationFileData = value;
if (value != null) {
}
}

static GetClassName(): any{return "Certification";
}
static ParseMandatory(el: any): any{return (!(CLMS.Framework.String.IsNullOrEmpty((el ?? '').trim())) && !(CLMS.Framework.String.IsNullOrEmpty(el)) && el == "ΝΑΙ" ? true : false);
}
static ParseSpecificValidityDuration(el: any): any{return (!(CLMS.Framework.String.IsNullOrEmpty((el ?? '').trim())) && !(CLMS.Framework.String.IsNullOrEmpty(el)) && el == "ΝΑΙ" ? true : false);
}
static ParseStatus(el: any): any{return (!(CLMS.Framework.String.IsNullOrEmpty((el ?? '').trim())) && !(CLMS.Framework.String.IsNullOrEmpty(el)) && el == "ΕΝΕΡΓΟ" ? Domain.CertificationStatus.Active : Domain.CertificationStatus.Inactive);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}